import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {faSyncAlt} from '@fortawesome/free-solid-svg-icons/faSyncAlt';
import {PrivateAreaService} from '../../services/private-area.service';
import {Contract} from '../../models/interface-contract';
import {PaginationInstance} from 'ngx-pagination';
import {Router} from "@angular/router";

@Component({
    selector: 'app-contracts',
    templateUrl: './contracts.component.html',
    styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit {

    @Output() codeContractEvent = new EventEmitter<number>();
    dataContracts: Contract[];
    faSyncAlt: any;
    paginatorConfig: PaginationInstance;
    showLoader: boolean;
    errormessage = '';
    textMessage: string;
    modalId: string;

    constructor(private privateAreaService: PrivateAreaService, private router: Router) {
        this.faSyncAlt = faSyncAlt;
        this.modalId = 'contract';
        this.paginatorConfig = {
            itemsPerPage: 4,
            currentPage: 1,
            id: 'paginator-current-contracts'
        };
    }

    ngOnInit(): void {
        this.privateAreaService.getActiveContracts().subscribe(res => {
            this.dataContracts = res;
            // console.log(this.dataContracts);
            this.dataContracts = this.dataContracts.filter( contract => {
                return contract.vigente === true;
            });
            // console.log('ALL CONTRACTS: ', this.dataContracts);
            if (res.length === 0) {
                this.errormessage = 'No existen contratos para este cliente.';
            }
        }, error => {
            this.showLoader = false;
            this.errormessage = 'Algo ha fallado, inténtalo más tarde.';
        });
    }

    requestContractRenewal(codContrato) {
        this.showLoader = true;
        this.privateAreaService.requestContractRenewal(codContrato).subscribe(res => {
            if (res.precioRecompraRenovacion > 0 && res.sequence) {
                sessionStorage.setItem('dataRenovation', JSON.stringify(res));
                this.router.navigateByUrl('resumen-de-renovacion');
            } else {
                this.showLoader = false;
                this.textMessage = 'Lo sentimos, el contrato no es renovable';
                document.getElementById(this.modalId).classList.remove('d-none');
            }
        }, error => {
            if (error.status === 400) {
                this.showLoader = false;
                this.textMessage = 'Lo sentimos, el contrato pertenece a ningún cliente';
                document.getElementById(this.modalId).classList.remove('d-none');
            } else {
                this.showLoader = false;
                this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                document.getElementById(this.modalId).classList.remove('d-none');
            }
        });
    }
}
